import { TEEUP_IMAGES } from "@config/teeupImages"

export const getRandomTeeupLocalImage = () => {
  const randomImgIndex = Math.floor(Math.random() * TEEUP_IMAGES.length)

  return TEEUP_IMAGES[randomImgIndex]
}
